import React from 'react';

import { Select } from 'antd';

import useFlightSearchBar from '@domain/flight/context/flight';
import { FlightSearchBarActionType } from '@domain/flight/context/flight/actions';
import { IFlightSearchBarState } from '@domain/flight/context/flight/state';

import { Wrapper, StyledTypography } from './styled';

const { Option } = Select;

const FlightCabinClass = () => {
  const { state, dispatch } = useFlightSearchBar();

  const handleChange = (event: string) => {
    const currentCabinClass = event as IFlightSearchBarState['cabinClass'];
    dispatch({
      type: FlightSearchBarActionType.SET_CABIN_CLASS,
      payload: currentCabinClass,
    });
  };

  return (
    <Wrapper>
      <StyledTypography>Kabin Sınıfı:</StyledTypography>
      <Select
        value={state?.cabinClass || 'All'}
        style={{ width: 120 }}
        onChange={handleChange}
      >
        <Option value='All'>Tümü</Option>
        <Option value='Business'>Business</Option>
        <Option value='Economy'>Ekonomi</Option>
      </Select>
    </Wrapper>
  );
};

export default FlightCabinClass;
